// extracted by mini-css-extract-plugin
export default {"profileBlockLabel":"account-sponsor-pending_profileBlockLabel__E5kHZ","root":"account-sponsor-pending_root__COJnM","colorBlue":"account-sponsor-pending_colorBlue__P-Mm8"};